// import { useContext } from '@nuxtjs/composition-api'
// import { env } from '@/src/shared/config'
// import { webPuchState } from './webPush.state'

// const PERMISSION_TIMEOUT = 15000

export function useWebPushPermission() {
  // const { $fire } = useContext()
  // let setTimeoutId: ReturnType<typeof setTimeout>

  // function webPushIsSupport(): boolean {
  //   return false
  //   // return !!$fire.messaging
  // }

  async function webPushPermissionInit() {
    // if (webPuchState.init) return
    // await $fire.messagingReady()
    // if (!webPushIsSupport()) return
    // webPuchState.init = true
  }

  function webPushPermissionCheck() {
    return undefined
    // if (process.server) return
    // if (!('Notification' in window)) return
    // if (Notification.permission !== 'granted') return
    // return webPushPermissionGet()
  }

  // function webPushPermissionTimeout(): Promise<boolean> {
  //   return new Promise((resolve) => {
  //     setTimeoutId = setTimeout(() => {
  //       webPuchState.permissionTimeout = true
  //       resolve(false)
  //     }, PERMISSION_TIMEOUT)
  //   })
  // }

  // async function webPushPermissionGet(): Promise<boolean> {
  //   webPuchState.permissionAsked = true
  //   webPuchState.permissionGranted = false
  //   webPuchState.permissionDenied = false
  //   try {
  //     const currentToken = await $fire.messaging.getToken({
  //       // vapidKey: env.FIREBASE_MESSAGE_VIPED_KEY,
  //     })
  //     if (setTimeoutId) clearTimeout(setTimeoutId)
  //     if (currentToken) {
  //       webPuchState.permissionGranted = true
  //       webPuchState.token = currentToken
  //       return true
  //     } else {
  //       webPuchState.permissionDenied = true
  //       return false
  //     }
  //   } catch (err) {
  //     webPuchState.permissionDenied = true
  //     if (setTimeoutId) clearTimeout(setTimeoutId)
  //     return false
  //   }
  // }

  function webPushPermissionAsk(): Promise<boolean> {
    return Promise.resolve(false)
    // webPuchState.permissionAsked = true
    // return Promise.race([webPushPermissionTimeout(), webPushPermissionGet()])
  }

  return {
    webPushPermissionInit,
    webPushPermissionCheck,
    webPushPermissionAsk,
  }
}
